exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PublishModal-module__modalContent2___3Jh6f .PublishModal-module__image-wrapper___1Q3uE{max-width:200px;display:flex;justify-content:center;margin:0 auto 1rem}.PublishModal-module__modalContent2___3Jh6f .PublishModal-module__checkbox___36EGm{margin-bottom:2rem}.PublishModal-module__modalContent2___3Jh6f h1,.PublishModal-module__modalContent2___3Jh6f p{margin-bottom:1rem}.PublishModal-module__modalContent2___3Jh6f a{color:#0827e9;cursor:pointer}.PublishModal-module__modalContent2___3Jh6f .PublishModal-module__inactive___2TAgg{opacity:.5;cursor:default!important}.PublishModal-module__modalContent2___3Jh6f .PublishModal-module__buttons-wrapper___22wBv{margin-top:2rem;display:grid;grid-auto-flow:column;gap:.5rem;justify-content:end}", ""]);

// exports
exports.locals = {
	"modalContent2": "PublishModal-module__modalContent2___3Jh6f",
	"image-wrapper": "PublishModal-module__image-wrapper___1Q3uE",
	"checkbox": "PublishModal-module__checkbox___36EGm",
	"inactive": "PublishModal-module__inactive___2TAgg",
	"buttons-wrapper": "PublishModal-module__buttons-wrapper___22wBv"
};